var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-card",
            { staticClass: "mt-24px card" },
            [
              _c(
                "v-row",
                { staticClass: "mb-4" },
                [
                  _c("v-col", [
                    _c("h2", { staticClass: "left mr-3" }, [
                      _vm._v("Dodatočné informácie "),
                      _vm.spoludlznik
                        ? _c("span", [_vm._v("- spolužiadateľ")])
                        : _vm._e()
                    ])
                  ])
                ],
                1
              ),
              _vm._l(_vm.rows, function(row, index) {
                return [
                  index == 3
                    ? [_c("v-divider", { key: index, staticClass: "mb-6" })]
                    : _vm._e(),
                  _vm.isScoringLoaded
                    ? _c(
                        "v-row",
                        { key: "row" + index },
                        [
                          _vm._l(row, function(column) {
                            return [
                              column.categoryId != 0
                                ? _c(
                                    "v-col",
                                    {
                                      key: column.categoryId,
                                      staticStyle: { "align-self": "end" },
                                      attrs: { cols: "4" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "sumar-dodat-info-label"
                                        },
                                        [_vm._v(_vm._s(column.label))]
                                      ),
                                      _c("br"),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "sumar-dodat-info-label-info"
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(column.labelInfo) + " "
                                          )
                                        ]
                                      ),
                                      column.type == "auto"
                                        ? [
                                            _c(
                                              "v-autocomplete",
                                              {
                                                staticClass:
                                                  "dynamic-input-control dynamic-input-sumar dense",
                                                attrs: {
                                                  items: column.items,
                                                  placeholder: "Zvoľte typ",
                                                  outlined: "",
                                                  "item-text": "display_member",
                                                  "item-value": "value_member",
                                                  rules: column.required
                                                    ? [_vm.rules.required]
                                                    : [],
                                                  stopMouseDown: ""
                                                },
                                                on: {
                                                  change: function(val) {
                                                    _vm.$emit("changeDirty")
                                                    if (
                                                      column.categoryId == 9800
                                                    ) {
                                                      _vm.$emit(
                                                        "checkRequireSpoludlznik",
                                                        column.value == 2
                                                      )
                                                    }
                                                  }
                                                },
                                                model: {
                                                  value: column.value,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      column,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "column.value"
                                                }
                                              },
                                              [
                                                column.valueInfo
                                                  ? _c(
                                                      "template",
                                                      { slot: "append-outer" },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              top: "",
                                                              "max-width": "350"
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key:
                                                                    "activator",
                                                                  fn: function(
                                                                    ref
                                                                  ) {
                                                                    var on =
                                                                      ref.on
                                                                    return [
                                                                      _c(
                                                                        "v-icon",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              " btn-help text-body-2",
                                                                            staticStyle: {
                                                                              cursor:
                                                                                "pointer"
                                                                            }
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " mdi-help-circle "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  }
                                                                }
                                                              ],
                                                              null,
                                                              true
                                                            )
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  column.valueInfo
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        : column.type == "date"
                                        ? [
                                            _c("DatePicker", {
                                              staticClass:
                                                "dynamic-input-sumar",
                                              attrs: {
                                                "hide-error-icon": "",
                                                placeholder: "DD/MM/YYYY",
                                                appendIcon: column.valueInfo
                                                  ? "mdi-help-circle"
                                                  : "",
                                                tooltipAppendIcon: column.valueInfo
                                                  ? column.valueInfo
                                                  : "",
                                                rules: [
                                                  column.id != 7
                                                    ? _vm.rules.required
                                                    : _vm.getZamestnanyOdReuired()
                                                ],
                                                stopMouseDown: ""
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.$emit(
                                                    "changeDirty"
                                                  )
                                                }
                                              },
                                              model: {
                                                value: column.value,
                                                callback: function($$v) {
                                                  _vm.$set(column, "value", $$v)
                                                },
                                                expression: "column.value"
                                              }
                                            })
                                          ]
                                        : [
                                            column.isAmount
                                              ? [
                                                  _c(
                                                    "numeric-text-box",
                                                    {
                                                      key: column.categoryId,
                                                      staticClass:
                                                        "dynamic-input-control dynamic-input-sumar",
                                                      attrs: {
                                                        suffix: "€",
                                                        rules: [
                                                          _vm.rules.required
                                                        ],
                                                        stopMouseDown: ""
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "changeDirty"
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: column.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            column,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "column.value"
                                                      }
                                                    },
                                                    [
                                                      column.valueInfo
                                                        ? _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    top: "",
                                                                    "max-width":
                                                                      "350"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "btn-help text-body-2",
                                                                                  staticStyle: {
                                                                                    cursor:
                                                                                      "pointer"
                                                                                  }
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  " mdi-help-circle "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        column.valueInfo
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "v-text-field",
                                                    {
                                                      key: column.categoryId,
                                                      staticClass:
                                                        "dynamic-input-control dynamic-input-sumar",
                                                      attrs: {
                                                        outlined: "",
                                                        rules: [
                                                          _vm.rules.required
                                                        ]
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.$emit(
                                                            "changeDirty"
                                                          )
                                                        },
                                                        mousedown: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      },
                                                      model: {
                                                        value: column.value,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            column,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "column.value"
                                                      }
                                                    },
                                                    [
                                                      column.valueInfo
                                                        ? _c(
                                                            "template",
                                                            { slot: "append" },
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    top: "",
                                                                    "max-width":
                                                                      "350"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "v-icon",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "btn-help ml-2 mt-1 text-body-2",
                                                                                  staticStyle: {
                                                                                    cursor:
                                                                                      "pointer"
                                                                                  }
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  " mdi-help-circle "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        column.valueInfo
                                                                      )
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    2
                                                  )
                                                ]
                                          ]
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              }),
              _c("v-divider"),
              _c(
                "v-row",
                { staticClass: "mt-8" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-checkbox", {
                        class: {
                          dynamic_check_box: true
                        },
                        staticStyle: {
                          "white-space": "nowrap",
                          "margin-top": "0px"
                        },
                        attrs: { label: "Chcem pridať ďalší príjem" },
                        on: {
                          change: function($event) {
                            return _vm.$emit("changeDirty")
                          }
                        },
                        model: {
                          value: _vm.showDalsiPrijem,
                          callback: function($$v) {
                            _vm.showDalsiPrijem = $$v
                          },
                          expression: "showDalsiPrijem"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showDalsiPrijem,
                      expression: "showDalsiPrijem"
                    }
                  ]
                },
                [
                  _c(
                    "v-col",
                    {
                      staticStyle: { "align-self": "end" },
                      attrs: { cols: "4" }
                    },
                    [
                      _c("span", { staticClass: "sumar-dodat-info-label" }, [
                        _vm._v(_vm._s(_vm.dalsiPrijem.inyTypPrijmu.label))
                      ]),
                      _c("br"),
                      _c(
                        "span",
                        { staticClass: "sumar-dodat-info-label-info" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.dalsiPrijem.inyTypPrijmu.labelInfo) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "v-autocomplete",
                        {
                          staticClass:
                            "dynamic-input-control dynamic-input-sumar dense",
                          attrs: {
                            items: _vm.dalsiPrijem.inyTypPrijmu.items,
                            placeholder: "Zvoľte typ",
                            outlined: "",
                            rules: _vm.showDalsiPrijem
                              ? [_vm.rules.required]
                              : [],
                            "item-text": "display_member",
                            "item-value": "value_member",
                            stopMouseDown: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.$emit("changeDirty")
                            }
                          },
                          model: {
                            value: _vm.dalsiPrijem.inyTypPrijmu.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dalsiPrijem.inyTypPrijmu,
                                "value",
                                $$v
                              )
                            },
                            expression: "dalsiPrijem.inyTypPrijmu.value"
                          }
                        },
                        [
                          _vm.dalsiPrijem.inyTypPrijmu.valueInfo
                            ? _c(
                                "template",
                                { slot: "append-outer" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "", "max-width": "350" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        " btn-help text-body-2",
                                                      staticStyle: {
                                                        cursor: "pointer"
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v(" mdi-help-circle ")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1177510222
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dalsiPrijem.inyTypPrijmu
                                              .valueInfo
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticStyle: { "align-self": "end" },
                      attrs: { cols: "4" }
                    },
                    [
                      _c("span", { staticClass: "sumar-dodat-info-label" }, [
                        _vm._v(_vm._s(_vm.dalsiPrijem.inyCistyPrijem.label))
                      ]),
                      _c("br"),
                      _c(
                        "span",
                        { staticClass: "sumar-dodat-info-label-info" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.dalsiPrijem.inyCistyPrijem.labelInfo) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "numeric-text-box",
                        {
                          staticClass:
                            "dynamic-input-control dynamic-input-sumar",
                          attrs: {
                            rules: _vm.showDalsiPrijem
                              ? [_vm.rules.required]
                              : [],
                            suffix: "€",
                            stopMouseDown: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.$emit("changeDirty")
                            }
                          },
                          model: {
                            value: _vm.dalsiPrijem.inyCistyPrijem.value,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.dalsiPrijem.inyCistyPrijem,
                                "value",
                                $$v
                              )
                            },
                            expression: "dalsiPrijem.inyCistyPrijem.value"
                          }
                        },
                        [
                          _vm.dalsiPrijem.inyCistyPrijem.valueInfo
                            ? _c(
                                "template",
                                { slot: "append" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "", "max-width": "350" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "btn-help text-body-2",
                                                      staticStyle: {
                                                        cursor: "pointer"
                                                      }
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v(" mdi-help-circle ")]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        4247872302
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dalsiPrijem.inyCistyPrijem
                                              .valueInfo
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }